/* VERVE bundle system v2 - storefront selection, live total, add to cart.
   Selection contract (Task 3 / Task 4). Three line properties are sent:
     _bundle           {"a":[{"id":"gid://shopify/ProductVariant/123","q":2}],"g":{"g-2":"gid://..."}}
     Bundle add-ons    "VER-EPD-015 x20, VER-RDA-001 x1"   (optional + choose_up_to picks)
     Bundle options    "VER-SAB-001, MVK-OBB-20K"          (choose_one picks)
   Shopify Functions do not receive underscore-prefixed properties, so the two
   visible ones are what actually reach checkout; _bundle stays for now and the
   function accepts either. Empty properties are omitted entirely.
   data-group is the group's 1-based index across ALL groups in order, matching
   the compiler's g-<n> keys. */
(function () {
  var root = document.querySelector('[data-bundle]');
  if (!root) return;

  var base = parseInt(root.getAttribute('data-price'), 10) || 0;
  var atc = root.querySelector('[data-bundle-atc]');
  var atcLabel = root.querySelector('[data-bundle-atc-label]');
  var msg = root.querySelector('[data-bundle-msg]');
  var defaultLabel = atcLabel ? atcLabel.textContent : 'ADD TO CART';

  function list(sel, ctx) {
    return Array.prototype.slice.call((ctx || root).querySelectorAll(sel));
  }

  /* The shop's money_format is "${{ amount_no_decimals }}", so every Liquid-rendered
     price on this page is a whole dollar figure. Match it exactly. */
  function money(cents) {
    return '$' + Math.round(cents / 100).toLocaleString('en-AU', {
      minimumFractionDigits: 0, maximumFractionDigits: 0
    });
  }

  function groupMax(grp, rule) {
    if (rule === 'choose_one') return 1;
    var max = parseInt(grp.getAttribute('data-max'), 10);
    return max > 0 ? max : Infinity;
  }

  /* Build-your-own percent bundles: the compiled data on the root carries pct, and the checkout
     prices every chosen line at list less that percentage. Mirror it in the live total. */
  var pctKeep = 1;
  try {
    var compiled = JSON.parse(root.getAttribute('data-compiled') || 'null');
    if (compiled && compiled.pct > 0 && compiled.pct < 100) pctKeep = 1 - compiled.pct / 100;
  } catch (e) { pctKeep = 1; }

  /* Swappable packs (1 Nov 2026). A choose_one group's first option ([data-default]) is the
     pack's default: the compiler already counts it in the product price (data-price), so the
     live total takes it out again before adding whatever is picked. Preselect it so the pack
     is ready to add as advertised. */
  var swapGroups = list('.bundle-group[data-rule="choose_one"]');
  swapGroups.forEach(function (grp) {
    if (grp.querySelector('.bundle-line__pick:checked')) return;
    var row = grp.querySelector('[data-line][data-default]:not([data-unavailable])') ||
      grp.querySelector('[data-line]:not([data-unavailable])');
    var pick = row && row.querySelector('.bundle-line__pick');
    if (pick) pick.checked = true;
  });
  function rowUnit(row) { return Math.round((parseInt(row.getAttribute('data-unit'), 10) || 0) * pctKeep) * (parseInt(row.getAttribute('data-qty'), 10) || 1); }
  function rowList(row) { return (parseInt(row.getAttribute('data-list'), 10) || 0) * (parseInt(row.getAttribute('data-qty'), 10) || 1); }
  var defaultsUnit = 0, defaultsList = 0;
  swapGroups.forEach(function (grp) {
    var d = grp.querySelector('[data-line][data-default]');
    if (d) { defaultsUnit += rowUnit(d); defaultsList += rowList(d); }
  });
  var listTotal = parseInt(root.getAttribute('data-list-total'), 10) || 0;

  function selection() {
    var addons = [], picks = {}, extra = 0, missing = false;
    /* Visible mirrors of the same choice. Shopify Functions never receive
       underscore-prefixed line properties, so _bundle alone never reaches
       checkout - these two do. */
    var addonSkus = [], optionSkus = [];

    list('.bundle-group').forEach(function (grp) {
      var rule = grp.getAttribute('data-rule');
      var key = 'g-' + grp.getAttribute('data-group');
      var max = groupMax(grp, rule);
      var picked = 0;

      if (rule !== 'included') {
        list('[data-line]', grp).forEach(function (row) {
          if (row.hasAttribute('data-unavailable')) return;
          var id = row.getAttribute('data-variant-id');
          var sku = (row.getAttribute('data-sku') || '').trim();
          var unit = parseInt(row.getAttribute('data-unit'), 10) || 0;
          var lineMax = parseInt(row.getAttribute('data-max'), 10) || 50;
          var input = row.querySelector('.bundle-line__qtyinput');
          var pick = row.querySelector('.bundle-line__pick');
          var q = 0;

          if (input) {
            q = parseInt(input.value, 10) || 0;
            if (q < 0) q = 0;
            if (q > lineMax) q = lineMax;
          } else if (pick && pick.checked) {
            q = parseInt(row.getAttribute('data-qty'), 10) || 1;
          }
          if (!q || picked >= max) return;

          if (rule === 'choose_one') {
            picks[key] = id;
            if (sku) optionSkus.push(sku);
          } else {
            addons.push({ id: id, q: q });
            if (sku) addonSkus.push(sku + ' x' + q);
          }
          extra += Math.round(unit * pctKeep) * q;
          picked += 1;
        });

        if (rule === 'choose_one' && !picks[key]) missing = true;
      }

      grp.setAttribute('data-picked', picked);
      grp.setAttribute('data-at-max', picked >= max ? 'true' : 'false');
    });

    return {
      a: addons, g: picks, extra: extra, missing: missing,
      addonSkus: addonSkus, optionSkus: optionSkus
    };
  }

  function refresh() {
    var sel = selection();

    var total = base - defaultsUnit + sel.extra;
    list('[data-bundle-total]').forEach(function (el) {
      el.textContent = money(total);
    });
    /* the mobile sticky bar shows the same live total */
    document.querySelectorAll('[data-sticky-cart-price]').forEach(function (el) { el.textContent = money(total); });

    if (swapGroups.length) {
      var chosenUnit = 0, chosenList = 0;
      swapGroups.forEach(function (grp) {
        var d = grp.querySelector('[data-line][data-default]');
        var dUnit = d ? rowUnit(d) : 0;
        list('[data-line]', grp).forEach(function (row) {
          var pick = row.querySelector('.bundle-line__pick');
          var on = !!(pick && pick.checked);
          row.classList.toggle('is-selected', on);
          if (on) { chosenUnit += rowUnit(row); chosenList += rowList(row); }
          var out = row.querySelector('[data-swap-delta]');
          if (!out) return;
          var diff = rowUnit(row) - dUnit;
          out.textContent = row === d ? 'Included' : (diff > 0 ? '+' + money(diff) : (diff < 0 ? 'Save ' + money(-diff) : 'Same price'));
          out.classList.toggle('is-save', diff < 0);
        });
      });
      var packNow = base - defaultsUnit + chosenUnit;
      var packList = listTotal - defaultsList + chosenList;
      var now = root.querySelector('.bundle-price__now');
      if (now) now.textContent = money(packNow);
      var was = root.querySelector('[data-bundle-was]');
      if (was) was.textContent = money(packList);
      var save = root.querySelector('[data-bundle-save]');
      if (save) save.textContent = 'Save ' + money(Math.max(0, packList - packNow));
    }

    list('.bundle-group').forEach(function (grp) {
      var atMax = grp.getAttribute('data-at-max') === 'true';
      var counter = grp.querySelector('[data-bundle-counter]');
      if (counter) {
        counter.textContent = grp.getAttribute('data-picked') + ' of ' +
          grp.getAttribute('data-max') + ' selected';
      }
      if (grp.getAttribute('data-rule') !== 'choose_up_to') return;
      list('.bundle-line__pick', grp).forEach(function (cb) {
        if (cb.type !== 'checkbox') return;
        cb.disabled = atMax && !cb.checked;
      });
    });

    if (atc) atc.disabled = sel.missing;
    if (msg) {
      msg.hidden = !sel.missing;
      if (sel.missing) msg.textContent = 'Choose an option in every group above to continue.';
    }
  }

  function step(row, delta) {
    var input = row.querySelector('.bundle-line__qtyinput');
    if (!input) return;
    var max = parseInt(input.getAttribute('max'), 10) || 50;
    var next = (parseInt(input.value, 10) || 0) + delta;
    if (next < 0) next = 0;
    if (next > max) next = max;
    input.value = next;
    refresh();
  }

  root.addEventListener('change', refresh);
  root.addEventListener('input', function (e) {
    if (e.target && e.target.classList.contains('bundle-line__qtyinput')) refresh();
  });

  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bundle-plus], [data-bundle-minus]');
    if (!btn) return;
    var row = btn.closest('[data-line]');
    if (!row) return;
    e.preventDefault();
    step(row, btn.hasAttribute('data-bundle-plus') ? 1 : -1);
  });

  /* ?add=SKU:qty,SKU  -> pre-tick / pre-fill rows by SKU */
  try {
    var pre = new URLSearchParams(window.location.search).get('add');
    if (pre) {
      pre.split(',').forEach(function (token) {
        var bits = token.split(':');
        var sku = bits[0].trim();
        var q = parseInt(bits[1], 10) || 1;
        if (!sku) return;
        var row = root.querySelector('[data-line][data-sku="' + sku.replace(/"/g, '') + '"]');
        if (!row || row.hasAttribute('data-unavailable')) return;
        var input = row.querySelector('.bundle-line__qtyinput');
        var pick = row.querySelector('.bundle-line__pick');
        if (input) input.value = q;
        else if (pick && !pick.disabled) pick.checked = true;
      });
    }
  } catch (err) { /* a malformed ?add= must never block the page */ }

  function openDrawer(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html || '';

    var fresh = tmp.querySelector('#cart-drawer');
    var current = document.getElementById('cart-drawer');
    if (fresh && current) current.innerHTML = fresh.innerHTML;

    var counts = tmp.querySelectorAll('.cart-count');
    if (counts.length) {
      var text = counts[0].textContent.trim();
      document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = text; });
    }

    if (current) current.classList.add('cart-summary--open');
    document.body.classList.add('cart-open', 'no-scroll');
    var overlay = document.querySelector('.cart-summary__overlay');
    if (overlay) overlay.classList.add('cart-overlay--open');

    var close = function () {
      var drawer = document.getElementById('cart-drawer');
      if (drawer) drawer.classList.remove('cart-summary--open');
      document.body.classList.remove('cart-open', 'no-scroll');
      var ov = document.querySelector('.cart-summary__overlay');
      if (ov) ov.classList.remove('cart-overlay--open');
    };
    document.querySelectorAll('.js-close-cart-icon').forEach(function (el) {
      el.addEventListener('click', close);
    });
    var overlayEl = document.querySelector('.js-close-cart-overlay');
    if (overlayEl) overlayEl.addEventListener('click', close);
  }

  function setLabel(text) {
    if (atcLabel) atcLabel.textContent = text;
    else if (atc) atc.textContent = text;
  }

  if (atc) {
    atc.addEventListener('click', function () {
      var sel = selection();
      if (sel.missing) { refresh(); return; }

      atc.disabled = true;
      setLabel('Adding...');

      var props = { _bundle: JSON.stringify({ a: sel.a, g: sel.g }) };
      if (sel.addonSkus.length) props['Bundle add-ons'] = sel.addonSkus.join(', ');
      if (sel.optionSkus.length) props['Bundle options'] = sel.optionSkus.join(', ');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: parseInt(root.getAttribute('data-variant-id'), 10),
            quantity: 1,
            properties: props
          }]
        })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart ' + r.status);
          return fetch('/?sections=header-new');
        })
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          openDrawer(sections['header-new']);
          atc.disabled = false;
          setLabel('ADDED');
          setTimeout(function () { setLabel(defaultLabel); }, 2000);
        })
        .catch(function () {
          atc.disabled = false;
          setLabel('Error - try again');
          setTimeout(function () { setLabel(defaultLabel); }, 3000);
        });
    });
  }

  refresh();
})();

